<template>
    <div v-if="getPoint">
        <invite-home-header page-name="招待" :istop="true"> </invite-home-header>
        <invite-home-point></invite-home-point>
        <invite-home-list></invite-home-list>
    </div>
</template>

<script>
    import InviteHomeHeader from 'pages/commons/header/Header'
    import InviteHomePoint from './components/Point'
    import InviteHomeList from './components/List'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            InviteHomeHeader,
            InviteHomePoint,
            InviteHomeList
        },
        created () {
            this.loadPoint()
        },
        mounted () {
            this.$store.dispatch('resetListObj')
        },
        computed: {
            ...mapGetters(['getPoint'])
        },
        methods: {
            loadPoint () {
                this.$store.dispatch('loadPoint')
            }
        }
    }
</script>

<style></style>
